import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function GoogleCallback() {
  const { applyAuth } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        applyAuth(data.token, data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user.role === "admin" ? "/admin" : "/account", { replace: true });
      })
      .catch(() => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/login", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="google-callback" className="min-h-screen flex flex-col items-center justify-center gap-4">
      <Loader2 size={36} className="animate-spin text-[#666]" />
      <p className="text-sm uppercase tracking-luxe text-[#999]">Signing you in…</p>
    </div>
  );
}
